import { render } from "./actions.vue?vue&type=template&id=63ffe5ee"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"

import "./actions.vue?vue&type=style&index=0&id=63ffe5ee&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__